module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp2_6005.e9da5f1f.png";